import { UpdatePage } from '@components/molecules';
import {
  AutocompleteElement,
  SwitchElement,
  TextFieldElement,
  useForm,
  UseFormSetValue,
} from 'react-hook-form-mui';
import API from '@apps/nnc/services/functionalarea';
import { ModelProps } from '@/types';
import {
  FunctionalAreaSchema,
  FunctionalAreaSchemaType,
} from '@apps/nnc/schemas/functionalarea';
import { Fragment, JSX, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import { setDefaultLanguageValues } from '@apps/localization/services/utils';
import { LANGUAGES_AVAILABLE } from '@/const';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const defaultValues = {
    translations: LANGUAGES_AVAILABLE.map((lang, idx) => ({
      language_code: {
        id: lang.id,
        label: lang.label,
      },
      inlineIndex: idx,
      is_active: true,
    })),
    order: 0,
  };
  const formContext = useForm<FunctionalAreaSchemaType>({
    resolver: zodResolver(FunctionalAreaSchema),
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (Object.keys(formContext.formState.errors).length > 0) {
      console.log('ZOD DATA', formContext.getValues());
      console.log('Zod validation errors:', formContext.formState.errors);
    }
  }, [formContext.formState.errors]);

  return (
    <UpdatePage
      schema={FunctionalAreaSchema}
      api={API}
      title={t('Functional Area')}
      modelProps={modelProps}
      formcontext={formContext}
      setChildValues={(setValue) => {
        setDefaultLanguageValues(
          setValue as UseFormSetValue<FunctionalAreaSchemaType>,
        );
      }}
      canSaveAndContinue
    >
      <>
        <Grid container sx={{ padding: 2 }} spacing={2}>
          {LANGUAGES_AVAILABLE.map((_item, idx) => (
            <Fragment key={idx}>
              <TextFieldElement
                name={`translations.${idx}.inlineIndex`}
                value={idx}
                type="hidden"
                sx={{ display: 'none' }}
              />

              <Grid size={{ xs: 12, md: 6 }}>
                <AutocompleteElement
                  name={`translations.${idx}.language_code`}
                  label={t('Language')}
                  options={LANGUAGES_AVAILABLE}
                  required
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextFieldElement
                  name={`translations.${idx}.name`}
                  label={t('Name')}
                  fullWidth
                  required
                />
              </Grid>
            </Fragment>
          ))}
          <Grid size={{ xs: 12, md: 6 }}>
            <TextFieldElement
              name="order"
              label={t('Order')}
              fullWidth
              type="number"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SwitchElement label={t('Is Active?')} name="is_active" />
          </Grid>
        </Grid>
      </>
    </UpdatePage>
  );
}
